// #region Imports
import { defineComponent } from "vue";
// #endregion
// #region Core
export default defineComponent({
    // #region Vars
    name: 'g-intranet-layout',
    // #endregion
    // #region Props
    props: {
        widthMode: {
            type: String,
            required: false,
            default: 'default'
        },
    },
    // #endregion
    // #region Computed
    computed: {
        getStickyMenu() {
            return this.$appHost.store.get("session")?.stickyMenu;
        },
    },
    // #endregion
});
// #endregion
